import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { defineCustomElements } from '@ionic/pwa-elements/loader'

import { AuthContextProvider } from './contexts/authContext'
import { ToastProvider } from './contexts/toastContext'
import App from './App'
import { PushNotificationContextProvider } from './notification/push-notification-context'
import * as serviceWorker from './serviceWorker'
import './firebase'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 5 * 60 * 60 * 1000,
      retry: 1,
    },
  },
})

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <QueryClientProvider client={queryClient}>
    <PushNotificationContextProvider>
      <ToastProvider>
        <AuthContextProvider>
          <App />
          {/* Workaround for https://github.com/tailwindlabs/headlessui/discussions/666 */}
          <div id="headlessui-portal-root">
            {/* It needs at least one child, so that HeadlessUI doesn't remove this portal root workaround
          ( https://github.com/tailwindlabs/headlessui/blob/main/packages/@headlessui-react/src/components/portal/portal.tsx#L84 ) */}
            <div />
          </div>
          <ReactQueryDevtools />
        </AuthContextProvider>
      </ToastProvider>
    </PushNotificationContextProvider>
  </QueryClientProvider>
)

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
